// extracted by mini-css-extract-plugin
export default {"headerView":"notes_headerView__FfeVm","tableContainer":"notes_tableContainer__TgOuS"};